import { render, staticRenderFns } from "./SelectedPresetDropdown.vue?vue&type=template&id=60af36d4&scoped=true"
import script from "./SelectedPresetDropdown.vue?vue&type=script&lang=js"
export * from "./SelectedPresetDropdown.vue?vue&type=script&lang=js"
import style0 from "./SelectedPresetDropdown.vue?vue&type=style&index=0&id=60af36d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60af36d4",
  null
  
)

export default component.exports